/* globals angular */
(function() {
  'use strict';

  angular
    .module('mandaeApp')
    .component('apiConfig', {
      template: require('./api-config.html'),
      controller: 'ApiConfigCtrl',
    })
    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('api-config', {
          parent: 'perfil',
          url: '/api-config',
          component: 'apiConfig',
          authenticate: true,
        });
    }]);

}());
